import { DataResult } from '../../utils/DataResult';
import {
  ConvertShoppingCartOptions,
  SaveShoppingCartOptions,
  ValidateShoppingCartOptions,
} from '../api';
import { BaseApiService, toRequestError } from './http';

export class ShoppingCartService extends BaseApiService {
  async getShoppingCart(key: string): Promise<string | undefined> {
    const baseUrl = await this.getBaseUrl();

    const response = await this.fetchApi.fetch(
      `${baseUrl}/shoppingcart/${encodeURIComponent(key)}`,
    );

    if (response.status === 404) {
      return undefined;
    }

    if (!response.ok) {
      throw await toRequestError(response);
    }

    const body: DataResult<{ value?: string }> | null = await response.json();

    return body?.data?.value;
  }

  async saveShoppingCart({
    key,
    projectKey,
    value,
  }: SaveShoppingCartOptions): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const query = new URLSearchParams({ projectKey });
    const now = new Date().toISOString();

    const response = await this.fetchApi.fetch(
      `${baseUrl}/shoppingcart/?${query.toString()}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: '00000000-0000-0000-0000-000000000000',
          discriminator: 'shoppingCart',
          created: now,
          lastModified: now,
          key,
          value,
        }),
      },
    );

    if (!response.ok) {
      throw await toRequestError(response);
    }
  }

  async deleteShoppingCart(key: string): Promise<void> {
    const baseUrl = await this.getBaseUrl();

    const response = await this.fetchApi.fetch(
      `${baseUrl}/shoppingcart/${encodeURIComponent(key)}`,
      { method: 'DELETE' },
    );

    if (!response.ok) {
      throw await toRequestError(response);
    }
  }

  async validateShoppingCart({
    key,
    projectKey,
    value,
    branchName,
  }: ValidateShoppingCartOptions): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const query = new URLSearchParams({ validateOnly: 'true' });

    if (projectKey) {
      query.set('projectKey', projectKey);
    }

    if (branchName) {
      query.set('branchName', branchName);
    }

    const response = await this.fetchApi.fetch(
      `${baseUrl}/project/shoppingCart/convert?${query.toString()}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, value }),
      },
    );

    if (!response.ok) {
      throw await toRequestError(response);
    }
  }

  async convertShoppingCart({
    projectKey,
    key,
    value,
  }: ConvertShoppingCartOptions): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const query = new URLSearchParams({ projectKey });

    const response = await this.fetchApi.fetch(
      `${baseUrl}/project/shoppingCart/convert?${query.toString()}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, value }),
      },
    );

    if (!response.ok) {
      throw await toRequestError(response);
    }
  }
}
